export type SignInType = "login" | "register" | "forgot"

export { default as ForgotPassword } from "./_components/forgot"
export { default as Login } from "./_components/login"
export { default as Register } from "./_components/register"
